"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[296],{

/***/ 296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ContactsElements": function() { return /* binding */ ContactsElements; },
  "default": function() { return /* binding */ Layout_Footer; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(29);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(1608);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(1555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(682);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(6896);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(4012);
// EXTERNAL MODULE: ./src/api/server.js + 54 modules
var server = __webpack_require__(5981);
;// CONCATENATED MODULE: ./src/assets/images/svg/nour-seen-logo.png
/* harmony default export */ var nour_seen_logo = ({"src":"/_next/static/media/nour-seen-logo.29a94a23.png","height":188,"width":266,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAAi0lEQVR42mMoEO1lZMABEm2nQeRCtSaKLw6f53mibK3RxfpNHAxAMCFiPkJjr8fMgEu1G/X/3/jAeq5tOz+SCYJAqpu13X2G4//2Lcy+hpM946yn5STZTbMFSgYCsRNYZabtVJGZYfNEgRIxSbbTyoASMUBcDMQKDMggxX4aD1DQBIg1gFg6yXYaCwBmQjI5hvaYswAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./src/assets/images/svg/arrow-up.svg
/* harmony default export */ var arrow_up = ({"src":"/_next/static/media/arrow-up.f1f1cecb.svg","height":21,"width":9});
;// CONCATENATED MODULE: ./src/assets/images/svg/email.svg
/* harmony default export */ var email = ({"src":"/_next/static/media/email.70be4c91.svg","height":22,"width":22});
;// CONCATENATED MODULE: ./src/assets/images/svg/location.svg
/* harmony default export */ var svg_location = ({"src":"/_next/static/media/location.5bc61274.svg","height":22,"width":22});
;// CONCATENATED MODULE: ./src/assets/images/svg/call_calling.svg
/* harmony default export */ var call_calling = ({"src":"/_next/static/media/call_calling.3ecfbe85.svg","height":22,"width":22});
// EXTERNAL MODULE: ./node_modules/sweetalert2/dist/sweetalert2.all.js
var sweetalert2_all = __webpack_require__(6455);
var sweetalert2_all_default = /*#__PURE__*/__webpack_require__.n(sweetalert2_all);
// EXTERNAL MODULE: ./src/components/handlers/index.js + 1 modules
var handlers = __webpack_require__(9400);
// EXTERNAL MODULE: ./src/utils/whatsapp.mjs
var whatsapp = __webpack_require__(735);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/Layout/Footer.js



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





















var Footer = function Footer(_ref) {
  var _data$siteInfo, _data$siteInfo2, _data$siteInfo3, _data$siteInfo4, _data$siteInfo4$appDe, _ref3, _data$siteInfo5, _data$siteInfo5$copyr, _data$siteInfo6, _data$siteInfo7;

  var data = _ref.data;

  var _useRouter = (0,router.useRouter)(),
      locale = _useRouter.locale;

  var _useIntl = (0,useIntl/* default */.Z)(),
      formatMessage = _useIntl.formatMessage;

  var socials = data === null || data === void 0 ? void 0 : data.socials; // ?.filter((link) =>
  //   ["instagram", "twitter", "facebook"]?.includes(link?.socialType?.name?.en)
  // );

  var _useState = (0,react.useState)(" "),
      email = _useState[0],
      setEmail = _useState[1];

  var _useState2 = (0,react.useState)(" "),
      emailMessage = _useState2[0],
      setEmailMessage = _useState2[1];

  (0,react.useEffect)(function () {
    setEmailMessage(formatMessage({
      id: "email"
    }));
  }, [locale, formatMessage]);
  (0,react.useEffect)(function () {
    var scrollProcess = function scrollProcess() {
      var _document;

      var scrollPos = 700;
      var ScrollBtn = (_document = document) === null || _document === void 0 ? void 0 : _document.querySelector(".scrollTop");

      function checkPosition() {
        var windowY = window.scrollY || 0;

        if (windowY > scrollPos) {
          // Scrolling UP
          ScrollBtn.classList.add("active");
        } else {
          // Scrolling DOWN
          ScrollBtn.classList.remove("active");
        } // scrollPos = windowY;

      }

      window.addEventListener("scroll", checkPosition);
    };

    scrollProcess();
  });

  var scrolly = function scrolly() {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(event) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault();
              _context.next = 3;
              return server/* default.post */.Z.post("/pages/subscribers/sections", {
                section: {
                  email: email
                }
              });

            case 3:
              sweetalert2_all_default().fire("".concat(formatMessage({
                id: "thanks"
              })), "".concat(formatMessage({
                id: "thankMsg"
              })), "success");
              event.target.email.value = "";

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var renderSocial = socials === null || socials === void 0 ? void 0 : socials.map(function (social, k) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: social === null || social === void 0 ? void 0 : social.link,
      target: "_blank",
      "aria-label": "social-link",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: social === null || social === void 0 ? void 0 : social.image,
        width: 20,
        height: 20,
        alt: "social-icon"
      })
    }, "info" + k);
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("footer", {
      className: "main-footer wrapper ",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "footer-top",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Row/* default */.Z, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
            className: "text-center",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "form-wrapper",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("form", {
                onSubmit: onSubmit,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "rounded-5 whatsapp",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                    href: (0,whatsapp/* buildWhatsAppUrl */.H)(data === null || data === void 0 ? void 0 : (_data$siteInfo = data.siteInfo) === null || _data$siteInfo === void 0 ? void 0 : _data$siteInfo.whatsup),
                    "aria-label": "whatsapp",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                      id: "send-whatsapp"
                    })
                  })
                })
              })
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Container/* default */.Z, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Row/* default */.Z, {
            className: "logo-social-div ",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Col/* default */.Z, {
              xs: 12,
              sm: 12,
              md: 12,
              lg: 5,
              xl: 5,
              xxl: 5,
              className: " d-flex flex-column justify-content-center align-items-center gap-4",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "logo-wrapper d-flex flex-column justify-content-center align-items-start gap-3",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "logo ",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                    href: "/",
                    "aria-label": "app-logo",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                      src: (0,handlers/* handleImage */.M)(data === null || data === void 0 ? void 0 : (_data$siteInfo2 = data.siteInfo) === null || _data$siteInfo2 === void 0 ? void 0 : _data$siteInfo2.appLogo),
                      width: "100",
                      height: "123",
                      alt: data === null || data === void 0 ? void 0 : (_data$siteInfo3 = data.siteInfo) === null || _data$siteInfo3 === void 0 ? void 0 : _data$siteInfo3.appName
                    })
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  children: data === null || data === void 0 ? void 0 : (_data$siteInfo4 = data.siteInfo) === null || _data$siteInfo4 === void 0 ? void 0 : (_data$siteInfo4$appDe = _data$siteInfo4.appDesc) === null || _data$siteInfo4$appDe === void 0 ? void 0 : _data$siteInfo4$appDe[locale]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: " social-div w-100",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: " socials",
                  children: renderSocial
                })
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Col/* default */.Z, {
              xs: 12,
              sm: 12,
              md: 12,
              lg: 3,
              xl: 3,
              xxl: 3,
              className: " links-wrapper ",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "fw-bold h3 text-start mb-3",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                  id: "links"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "links-container",
                children: (_ref3 = ["home", "recruitmentCountries", "personnel", "recruitmentRequest", "blogs", "about-us", "faq", "contact-us", "privacyPolicy", "termsConditions"]) === null || _ref3 === void 0 ? void 0 : _ref3.map(function (item, index) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "link-item",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                      href: item === "home" ? "/" : "/".concat(item),
                      legacyBehavior: true,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        "aria-label": "link-item",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                          id: item
                        })
                      })
                    })
                  }, index);
                })
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
              xs: 12,
              sm: 12,
              md: 12,
              lg: 4,
              xl: 4,
              xxl: 4,
              className: "scrollTop-wrapper d-flex align-items-start justify-content-start mt-4 p-0",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "contact-info pb-0 ms-0 d-flex flex-column justify-content-center align-items-start",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContactsElements, {
                  initdata: data,
                  locale: locale
                })
              })
            })]
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "footer-bottom",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Row/* default */.Z, {
          className: "align-items-center justify-content-between",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
            xs: "12",
            md: "4",
            className: "m-auto m-lg-0",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "social d-flex text-center",
              children: data === null || data === void 0 ? void 0 : (_data$siteInfo5 = data.siteInfo) === null || _data$siteInfo5 === void 0 ? void 0 : (_data$siteInfo5$copyr = _data$siteInfo5.copyright) === null || _data$siteInfo5$copyr === void 0 ? void 0 : _data$siteInfo5$copyr[locale]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
            xs: "12",
            md: "4",
            className: "m-auto m-lg-0"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
            xs: "12",
            md: "4",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              className: "developed-by text-center gap-1 align-items-center",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                  id: "developed"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "https://nsn.sa/",
                target: "_blank",
                "aria-label": "logo-nsn",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  src: nour_seen_logo,
                  alt: "ejjadh logo",
                  width: 50,
                  height: 40,
                  style: {
                    objectFit: "contain"
                  }
                })
              })]
            })
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        onClick: scrolly,
        className: "scrollTop",
        type: "button",
        "aria-label": "up-button",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: arrow_up.src,
          width: 10,
          height: 20,
          alt: "up-button"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: "tel:".concat(data === null || data === void 0 ? void 0 : (_data$siteInfo6 = data.siteInfo) === null || _data$siteInfo6 === void 0 ? void 0 : _data$siteInfo6.phone),
        className: "float phone",
        target: "_blank",
        rel: "noreferrer",
        "aria-label": "whatsapp",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "my-float",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), _objectSpread(_objectSpread({}, call_calling), {}, {
            alt: "calling-icon",
            width: 35,
            height: 35
          }))
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        href: (0,whatsapp/* buildWhatsAppUrl */.H)(data === null || data === void 0 ? void 0 : (_data$siteInfo7 = data.siteInfo) === null || _data$siteInfo7 === void 0 ? void 0 : _data$siteInfo7.whatsup),
        className: "float",
        target: "_blank",
        rel: "noreferrer",
        "aria-label": "whatsapp",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "my-float",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 448 512",
            fill: "#fff",
            width: "60%",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
              d: "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
            })
          })
        })
      })]
    })
  });
};

/* harmony default export */ var Layout_Footer = (Footer);
var ContactsElements = function ContactsElements(_ref4) {
  var _initdata$siteInfo, _initdata$siteInfo2, _initdata$siteInfo3, _initdata$siteInfo4, _initdata$siteInfo5, _initdata$siteInfo5$l, _initdata$siteInfo6, _initdata$siteInfo6$l, _initdata$siteInfo6$l2;

  var initdata = _ref4.initdata,
      locale = _ref4.locale;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "contact-element",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "icon",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: email,
          alt: "email-icon"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "contact-details",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "unique-bold",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "email"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "mailto:".concat(initdata === null || initdata === void 0 ? void 0 : (_initdata$siteInfo = initdata.siteInfo) === null || _initdata$siteInfo === void 0 ? void 0 : _initdata$siteInfo.email),
            "aria-label": "email-link",
            children: initdata === null || initdata === void 0 ? void 0 : (_initdata$siteInfo2 = initdata.siteInfo) === null || _initdata$siteInfo2 === void 0 ? void 0 : _initdata$siteInfo2.email
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "contact-element",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "icon",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: call_calling,
          alt: "calling-link"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "contact-details",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "unique-bold",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "phone"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "tel:".concat(initdata === null || initdata === void 0 ? void 0 : (_initdata$siteInfo3 = initdata.siteInfo) === null || _initdata$siteInfo3 === void 0 ? void 0 : _initdata$siteInfo3.phone),
            "aria-label": "phone-link",
            children: initdata === null || initdata === void 0 ? void 0 : (_initdata$siteInfo4 = initdata.siteInfo) === null || _initdata$siteInfo4 === void 0 ? void 0 : _initdata$siteInfo4.phone
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "contact-element",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "icon",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: svg_location,
          alt: "location"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "contact-details",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "unique-bold",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "address"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: (initdata === null || initdata === void 0 ? void 0 : (_initdata$siteInfo5 = initdata.siteInfo) === null || _initdata$siteInfo5 === void 0 ? void 0 : (_initdata$siteInfo5$l = _initdata$siteInfo5.locationAddress) === null || _initdata$siteInfo5$l === void 0 ? void 0 : _initdata$siteInfo5$l.link) || "",
          target: "_blank",
          rel: "noopener noreferrer",
          className: "map-link",
          children: (initdata === null || initdata === void 0 ? void 0 : (_initdata$siteInfo6 = initdata.siteInfo) === null || _initdata$siteInfo6 === void 0 ? void 0 : (_initdata$siteInfo6$l = _initdata$siteInfo6.locationAddress) === null || _initdata$siteInfo6$l === void 0 ? void 0 : (_initdata$siteInfo6$l2 = _initdata$siteInfo6$l.title) === null || _initdata$siteInfo6$l2 === void 0 ? void 0 : _initdata$siteInfo6$l2[locale]) || (locale === "ar" ? "العنوان على الخريطة" : "View location on map")
        })]
      })]
    })]
  });
};

/***/ }),

/***/ 9400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ handleImage; }
});

;// CONCATENATED MODULE: ./src/assets/images/placeholder.jpg
/* harmony default export */ var placeholder = ({"src":"/_next/static/media/placeholder.75cf2fc2.jpg","height":319,"width":474,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAUACAMBIgACEQEDEQH/xAAnAAEBAAAAAAAAAAAAAAAAAAAABwEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAAAsgP/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/9oACAEBAAE/AH//xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oACAECAQE/AH//xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oACAEDAQE/AH//2Q==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/components/handlers/index.js

var handleImage = function handleImage(image) {
  var _ref;

  if ((_ref = "".concat(image)) !== null && _ref !== void 0 && _ref.includes("http")) return image;

  if (image) {
    if (!image.startsWith("/")) image = "/".concat(image);
    return "".concat("https://alnojoom.ejjadh.info/").concat(image);
  }

  return image || (placeholder === null || placeholder === void 0 ? void 0 : placeholder.src);
};

/***/ }),

/***/ 1555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export useCol */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);
"use client";





function useCol({
  as,
  bsPrefix,
  className,
  ...props
}) {
  bsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'col');
  const breakpoints = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapBreakpoints */ .pi)();
  const minBreakpoint = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapMinBreakpoint */ .zG)();
  const spans = [];
  const classes = [];
  breakpoints.forEach(brkPoint => {
    const propValue = props[brkPoint];
    delete props[brkPoint];
    let span;
    let offset;
    let order;
    if (typeof propValue === 'object' && propValue != null) {
      ({
        span,
        offset,
        order
      } = propValue);
    } else {
      span = propValue;
    }
    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
    if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
    if (order != null) classes.push(`order${infix}-${order}`);
    if (offset != null) classes.push(`offset${infix}-${offset}`);
  });
  return [{
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, ...spans, ...classes)
  }, {
    as,
    bsPrefix,
    spans
  }];
}
const Col = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref) => {
  const [{
    className,
    ...colProps
  }, {
    as: Component = 'div',
    bsPrefix,
    spans
  }] = useCol(props);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ...colProps,
    ref: ref,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, !spans.length && bsPrefix)
  });
});
Col.displayName = 'Col';
/* harmony default export */ __webpack_exports__["Z"] = (Col);

/***/ }),

/***/ 682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);
"use client";





const Container = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  fluid = false,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  className,
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'container');
  const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, fluid ? `${prefix}${suffix}` : prefix)
  });
});
Container.displayName = 'Container';
/* harmony default export */ __webpack_exports__["Z"] = (Container);

/***/ }),

/***/ 1608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);
"use client";





const Row = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const decoratedBsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'row');
  const breakpoints = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapBreakpoints */ .pi)();
  const minBreakpoint = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapMinBreakpoint */ .zG)();
  const sizePrefix = `${decoratedBsPrefix}-cols`;
  const classes = [];
  breakpoints.forEach(brkPoint => {
    const propValue = props[brkPoint];
    delete props[brkPoint];
    let cols;
    if (propValue != null && typeof propValue === 'object') {
      ({
        cols
      } = propValue);
    } else {
      cols = propValue;
    }
    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
    if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, decoratedBsPrefix, ...classes)
  });
});
Row.displayName = 'Row';
/* harmony default export */ __webpack_exports__["Z"] = (Row);

/***/ }),

/***/ 735:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ buildWhatsAppUrl; }
/* harmony export */ });
/* unused harmony export WHATSAPP_MESSAGE */
var WHATSAPP_MESSAGE = "السلام عليكم ورحمة الله و بركاتة، وصلت إليكم من خلال موقع النجوم المميزة للاستقدام، وأرغب في الاستفسار عن خدمات الاستقدام والعروض المتاحة.";
var buildWhatsAppUrl = function buildWhatsAppUrl(phone) {
  return "https://wa.me/".concat(phone !== null && phone !== void 0 ? phone : "", "?text=").concat(encodeURIComponent(WHATSAPP_MESSAGE));
};

/***/ })

}]);